// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileEmptyState-cls1__ab159258be923dc8b1f3","cls2":"ProfileEmptyState-cls2___24e1d4037936a835076 ProfileEmptyState-cls1__ab159258be923dc8b1f3"};